import SignIn from "./Illustrations/SignIn.svg";
import SignUp from "./Illustrations/SignUp.svg";

export * from "./icons/CloseIcon";
export const Illustrations = {
  SignUp,
  SignIn
};